module.exports = __webpack_public_path__ + "static/media/EntDetailsScreen_elGooglePlayStore_926386.85887edf.png";